import React from "react";
import {
  PeopleOutline,
  LogOutOutline,
  ListSharp,
  CalendarOutline,
  BookmarkOutline,
  DocumentText,
  JournalOutline,
  StatsChartOutline,
  SyncOutline,
} from "react-ionicons";
import {
  FcManager,
  FcBarChart,
  FcBullish,
  FcBearish,
  FcCalendar,
  FcComboChart,
  FcSurvey,
  FcSalesPerformance,
  FcNews,
  FcSynchronize,
  FcCancel,
  FcBusinessman,
  FcEditImage,
} from "react-icons/fc";
import ProgressBar from "react-bootstrap/ProgressBar";
import { ArrowBackCircle } from "react-ionicons";
import { BsBarChartFill } from "react-icons/bs";
import { set, get } from "idb-keyval";
import { LiaClipboardListSolid } from "react-icons/lia";
import { LuDatabaseBackup } from "react-icons/lu";
import { GrSchedule } from "react-icons/gr";
import { TbTargetArrow } from "react-icons/tb";
import stylesASAP from "./stylesASAP";
import { Modal } from "react-bootstrap";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import _post from "../Functions/Post";
import constantURI from "../URI";
import { v4 as uuidv4 } from "uuid";
import CollectingASAP from "../Functions/CollectingDataASAP";
import SendingData from "../Functions/SendingDataASAP";
import SalesGauge from "./SalesGauge";
import ClientsGuage from "./ClientsGuage";

export default class LandingPage extends React.Component {
  constructor() {
    super();
    this.state = {
      showAlertChange: false,
      dateOut: "",
      dateIn: "",
      addressDateOut: "",
      addressDateIn: "",
      timeIn: "",
      timeOut: "",
      latitudeOut: "",
      longitudeIn: "",
      disableDate: false,
      disableout: false,
      reps: [],
      repId: "",
      ids: "",
      punchday: [],
      count: 0,
      punch: {},
      showSend: false,
      showReceive: false,
      isDoneReceiving: false,
      disableSend: false,
      username: "",
      showAlertSale: false,
      active: true,
      color: "65a0ff",
      blink: false,
      allitems: [],
      settingArray: [],
      showAlertImages: false,
      random: 0,
      selectedClientDetails: [],
      showAlert: false,
    };
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    const date = new Date();
    const DateIn = localStorage.getItem("DateIn");
    const DateOut = localStorage.getItem("DateOut");
    const TimeIn = localStorage.getItem("TimeIn");
    const TimeOut = localStorage.getItem("TimeOut");
    const LongIn = localStorage.getItem("LongitudeIn");
    const LatIn = localStorage.getItem("LatitudeIn");
    const LongOut = localStorage.getItem("LongitudeOut");
    const LatOut = localStorage.getItem("LatitudeOut");
    const AdressOut = localStorage.getItem("AdressOut");
    const Attid = localStorage.getItem("ids");
    const token = localStorage.getItem("Token");
    const punchday = localStorage.getItem("UnsyncedPunchDay");
    const count = localStorage.getItem("UnsyncedPunchCount");
    const username = localStorage.getItem("Username");
    const settingArray = JSON.parse(localStorage.getItem("SettingArray"));
    const selectedClientDetails = JSON.parse(
      localStorage.getItem("SelectedClientDetails")
    );

    await this.setState({
      dateIn: JSON.parse(DateIn),
      username: JSON.parse(username),
      ids: JSON.parse(Attid),
      punchday: JSON.parse(punchday),
      count: JSON.parse(count),
      dateOut: JSON.parse(DateOut),
      timeIn: JSON.parse(TimeIn),
      timeOut: JSON.parse(TimeOut),
      addressDateOut: JSON.parse(AdressOut),
      longitudeIn: JSON.parse(LongIn),
      latitudeIn: JSON.parse(LatIn),
      longitudeOut: JSON.parse(LongOut),
      latitudeOut: JSON.parse(LatOut),
      token: JSON.parse(token),
      settingArray: settingArray,
      selectedClientDetails: selectedClientDetails,
    });

    this.interval = setInterval(() => {
      this.setState((prevState) => ({
        blink: !prevState.blink, // Toggle blinking state
      }));
    }, 400); // Change 1000 to adjust blink speed

    if (
      this.state.dateIn !== date.toISOString().substring(0, 10) &&
      this.state.dateIn !== null
    ) {
      await this.setState({
        dateIn: "",
        timeIn: "",
        addressDateIn: "",
        latitudeIn: "",
        longitudeIn: "",
      });
    }
    if (
      this.state.dateOut !== date.toISOString().substring(0, 10) &&
      this.state.dateOut !== null
    ) {
      await this.setState({
        dateOut: "",
        timeOut: "",
        addressDateOut: "",
        latitudeOut: "",
        longitudeOut: "",
      });
    }
    if (this.state.dateIn === null || this.state.dateIn === "") {
      this.setState({ disableDate: false });
    } else {
      this.setState({ disableDate: true });
    }

    if (this.state.dateOut === null || this.state.dateOut === "") {
      this.setState({ disableout: false });
    } else {
      this.setState({ disableout: true });
    }

     const rep = JSON.parse(localStorage.getItem("Representative"));
    const user = JSON.parse(localStorage.getItem("User"));
    if (!user || !Array.isArray(user) || !user[0] || !user[0].partner_id) {
      if (navigator.onLine) {
        window.localStorage.clear();
      }
      this.props.history.push("./");
      return;
    }
    await this.setState({ reps: rep, repId: user[0].partner_id[0] });
    await this.readItems();
  }

  componentWillUnmount() {
    clearInterval(this.interval); // Cleanup on component unmount
  }

  componentDidUpdate(prevProps, prevState) {
    // Change color based on blinking state
    if (prevState.blink !== this.state.blink) {
      this.setState({
        color: this.state.blink ? "#ff4141" : "#65a0ff",
      });
    }
  }
  readItems = async () => {
    try {
      // Use 'get' method from idb-keyval to read data from IndexedDB
      const data = await get("items");

      if (data) {
        this.setState({ allitems: data });
        console.log(data);
        console.log("items from IndexedDB:", data);
      } else {
        console.log("items not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading items from IndexedDB:", error);
    }
  };
  showAlert = () => {
    this.setState({ showAlert: true });
  };
  closeAlert = () => {
    this.setState({ showAlert: false });
  };

  showAlertImages = () => {
    const d = new Date();
    d.setDate(d.getDate());
    console.log(d.getTime());
    this.setState({ random: d.getTime() });
    localStorage.setItem("random", JSON.stringify(d.getTime()));
    this.setState({ showAlertImages: true });
    // List of images you want to cache
    const imageUrlsToCache = [];
    let count = 0;
    // Make sure the list of items exists and has valid URLs
    if (this.state.allitems && Array.isArray(this.state.allitems)) {
      this.setState({ imageCount: 0 });
      this.state.allitems.forEach((item, index) => {
        {
          this.state.settingArray.map((url) => {
            if (url.key === "Product_Images_Base_URL") {
              const imageUrl =
                url.value + item.default_code + ".png?lastmod=" + d.getTime();
              imageUrlsToCache.push(imageUrl);
              setTimeout(() => {
                count++;
                // Update the image count in the state after caching each image
                this.setState({ imageCount: count });
                // Once all images are cached, you can perform any other actions if needed
                if (count === this.state.allitems.length) {
                  console.log("All images cached successfully.");
                }
              }, 200 * index);
            }
          });
        }
      });
    } else {
      console.warn("No items available for caching.");
      return;
    }
    // Log the image URLs to verify
    console.log("Image URLs to cache:", imageUrlsToCache);
    // Send the image URLs to the service worker for caching
    if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: "CLEAR_CACHE",
      });
      navigator.serviceWorker.controller.postMessage({
        type: "CACHE_IMAGES",
        imageUrls: imageUrlsToCache,
        mode: "no-cors",
      });
      console.log("Sent image URLs to service worker for caching.");
    } else {
      console.error("Service worker not available or not ready.");
    }
    // Proceed with the rest of the login logic (redirect, fetch user data, etc.)
  };

  // showAlertImages = async () => {
  //   const d = new Date();
  //   d.setDate(d.getDate());
  //   console.log(d.getTime());

  //   this.setState({ showAlertImages: true, random: d.getTime() });
  //   await localStorage.setItem("random", JSON.stringify(d.getTime()));
  // };

  closeAlertImages = () => {
    this.setState({ showAlertImages: false, showAlert: false });
  };

  items = () => {
    this.props.history.push("./ItemsASAP");
  };
  Journal = () => {
    this.props.history.push("./Journal");
  };

  Schedule = () => {
    localStorage.setItem("isSchedule", JSON.stringify(1));
    localStorage.setItem("isVendor", JSON.stringify(false));
    this.props.history.push("./Client");
  };

  Client = () => {
    localStorage.setItem("isSchedule", JSON.stringify(2));
    localStorage.setItem("isVendor", JSON.stringify(false));
    this.props.history.push("/Client");
  };

  Vendor = () => {
    localStorage.setItem("isVendor", JSON.stringify(true));
    localStorage.setItem("isSchedule", JSON.stringify(0));
    this.props.history.push("/Client");
  };

  closeAlertChange = () => {
    this.setState({ showAlertChange: false });
  };

  showAlertChange = () => {
    this.setState({ showAlertChange: true });
  };

  closeAlertSale = () => {
    this.setState({ showAlertSale: false });
  };

  showAlertSale = () => {
    this.setState({ showAlertSale: true });
  };
  DateIn = async () => {
    const d = new Date();
    d.setDate(d.getDate());
    await this.setState({
      dateIn: d.toISOString().substring(0, 10),
      // timeIn: d.getHours() + d.toISOString().substring(13, 19),
      timeIn:
        ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19),
      disableDate: true,
    });
    localStorage.setItem("DateIn", JSON.stringify(this.state.dateIn));
    localStorage.setItem("TimeIn", JSON.stringify(this.state.timeIn));

    const CreateAttendance =
      constantURI() +
      "CreateAttendance?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&checkIn=" +
      this.state.dateIn +
      " " +
      this.state.timeIn +
      "&longIn=" +
      "0" +
      "&latIn=" +
      "0" +
      "&employeeId=" +
      this.state.repId;

    this.state.punch.Url = CreateAttendance;
    this.state.punch.state = "Unsynced";

    await this.state.punchday.push(this.state.punch);
    this.setState({ count: this.state.count + 1 });
    await localStorage.setItem(
      "UnsyncedPunchCount",
      JSON.stringify(this.state.count)
    );
    await localStorage.setItem(
      "UnsyncedPunchDay",
      JSON.stringify(this.state.punchday)
    );

    //await localStorage.setItem('DailyData', JSON.stringify([]));
    //await localStorage.setItem('DailySummaryReport', JSON.stringify([]));
  };

  DateOut = async () => {
    await this.setState({ disableSend: true });
    const d = new Date();
    d.setDate(d.getDate());
    await this.setState({
      dateOut: d.toISOString().substring(0, 10),
      timeOut:
        ("0" + d.getHours()).slice(-2) + d.toISOString().substring(13, 19),
      // timeOut: d.getHours() + d.toISOString().substring(13, 19),
      disableout: true,
    });

    localStorage.setItem("DateOut", JSON.stringify(this.state.dateOut));
    localStorage.setItem("TimeOut", JSON.stringify(this.state.timeOut));
    var uuid = uuidv4();
    this.state.punchday.map(async (day, index, arr) => {
      if (day.Url === undefined) {
        const UpdateAttendance =
          constantURI() +
          "UpdateAttendance?token=" +
          this.state.token +
          "&user=" +
          this.state.username +
          "&checkOut=" +
          this.state.dateOut +
          " " +
          this.state.timeOut +
          "&longOut=" +
          "0" +
          "&latOut=" +
          "0" +
          "&employeeId=" +
          this.state.repId +
          "&lineid=" +
          this.state.ids;
        await this.state.punchday.map(async (item, index) => {
          const lastIndex = this.state.punchday.length - 1;
          this.state.punch = this.state.punchday[lastIndex];

          // insert fields to the last object of array
          this.state.punch.updateUrl = UpdateAttendance;
        });
      } else {
        const UpdateAttendance =
          constantURI() +
          "UpdateAttendance?token=" +
          this.state.token +
          "&user=" +
          this.state.username +
          "&checkOut=" +
          this.state.dateOut +
          " " +
          this.state.timeOut +
          "&longOut=" +
          "0" +
          "&latOut=" +
          "0" +
          "&employeeId=" +
          this.state.repId +
          "&lineid=" +
          uuid;
        await this.state.punchday.map(async (item, index) => {
          const lastIndex = this.state.punchday.length - 1;
          this.state.punch = this.state.punchday[lastIndex];

          // insert fields to the last object of array
          this.state.punch.updateUrl = UpdateAttendance;
        });
      }
    });

    this.setState({ count: this.state.count + 1 });
    await localStorage.setItem(
      "UnsyncedPunchCount",
      JSON.stringify(this.state.count)
    );
    await localStorage.setItem(
      "UnsyncedPunchDay",
      JSON.stringify(this.state.punchday)
    );
    await this.setState({ disableSend: false });
  };

  onSync = async () => {
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });
    if (this.state.authenticate) {
      this.state.punchday.map(async (day, index, arr) => {
        if (day.Url !== undefined) {
          await _post(day.Url).then(async (response) => {
            return response.json().then(async (data) => {
              if (data.result !== undefined) {
                this.setState({ ids: data.result });
                localStorage.setItem("ids", JSON.stringify(this.state.ids));
                if (day.updateUrl !== undefined) {
                  const newURL =
                    day.updateUrl.substring(
                      0,
                      day.updateUrl.indexOf("&lineid=") + 8
                    ) + data.result;
                  await this.setState({
                    ...(this.state.punchday[index].updateUrl = newURL),
                  });
                }
              } else {
                this.setState({ alertUndefined: true });
              }
            });
          });
        }
        if (day.updateUrl !== undefined) {
          await _post(day.updateUrl);
        }
        if (index === arr.length - 1) {
          await localStorage.setItem("UnsyncedPunchCount", JSON.stringify(0));
          await localStorage.setItem("UnsyncedPunchDay", JSON.stringify([]));
          await alert("Synced Successfully");

          window.location.reload();
        }
      });
    } else {
      alert("Only sync when connected to the Internet!");
      await this.setState({ loading: false });
    }
  };

  showSend = async () => {
    this.setState({ logDisable: false });
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });

    if (this.state.authenticate) this.setState({ showSend: true });
    else alert("Please connect to the internet.");
  };

  showReceive = async () => {
    await ASAPAuthenticate().then((response) => {
      this.setState({ authenticate: response });
    });

    if (this.state.authenticate) this.setState({ showReceive: true });
    else alert("Please connect to the internet.");
  };

  closeReceive = () => {
    this.setState({ showReceive: false });
  };

  closeSend = () => {
    this.setState({ showSend: false });
  };

  updateIsDoneReceiving = (value) => {
    this.setState({ isDoneReceiving: value });
  };

  productAsap = () => {
    this.props.history.push("./Catalogs");
    localStorage.setItem("CatalogType", JSON.stringify(1));
  };

  render() {
    return (
      <div className="container-fluid vh-100" style={stylesASAP.mainContainer}>
        {this.state.active ? (
          this.state.count === 0 || this.state.count === null ? (
            <div className="alert alert-primary ">
              <FcCancel
                size={35}
                className=" floatRight"
                onClick={() => this.setState({ active: false })}
              />
              {/* <button
                type="button"
                className="btn btn-secondary close floatRight"
                data-dismiss="alert"
                onClick={() => this.setState({ active: false })}
              >
                &times;
              </button> */}
              You have 0 Punch to Sync with Odoo.
            </div>
          ) : (
            <div className="alert alert-dark   ">
              <FcCancel
                size={35}
                className=" floatRight"
                onClick={() => this.setState({ active: false })}
              />
              {/* <button
                type="button"
                className="btn btn-secondary close floatRight"
                data-dismiss="alert"
                onClick={() => this.setState({ active: false })}
              >
                &times;
              </button> */}
              You have {this.state.count} Punches to Sync with Odoo.{" "}
              <b>Only sync when connected to the Internet!</b>
            </div>
          )
        ) : null}

        {/* <div className="floatRight mb-2">
         
          <button className="btn">
            <LogOutOutline
              className="floatRight"
              height="40px"
              width="50px"
              style={{ color: "red" }}
              onClick={this.showAlertChange}
            />
          </button>
        </div> */}

        <div className="row text-center mt-4" style={{ clear: "both" }}>
          <div className="col floatLeft">
            {!this.state.disableDate ? (
              <div
                className={"btn dateInOut"}
                style={{ backgroundColor: this.state.color }}
                onClick={this.DateIn}
              >
                <b>Punch In</b>
              </div>
            ) : (
              <div className={"btn disabled dateInOut"} onClick={this.DateIn}>
                <b>Punch In</b>
              </div>
            )}

            <p className="col mt-3">
              {this.state.dateIn === null || this.state.timeIn === null
                ? null
                : this.state.dateIn + " " + this.state.timeIn}
            </p>
          </div>

          <div className="col floatRight">
            <div
              className={
                !this.state.disableout && this.state.disableDate
                  ? "btn dateInOut"
                  : "btn disabled dateInOut"
              }
              onClick={this.DateOut}
            >
              <b>Punch Out</b>
            </div>
            <p className="col mt-3">
              {this.state.dateOut === null || this.state.timeOut === null
                ? null
                : this.state.dateOut + " " + this.state.timeOut}
            </p>
          </div>
        </div>

        <div className="col mt-3 m-3 mb-3" style={{ clear: "both" }}>
          <div
            className="row floatLeft  Box-Shadow text-center "
            style={{ marginRight: "30px", marginBottom: "20px" }}
          >
            <label className="h6" color={"#ff0000"}>
              <b>TRANS. LOG</b>
            </label>
            <LuDatabaseBackup
              size={50}
              className="row align-items-center justify-content-center"
              style={{ color: "red" }}
              onClick={() => this.props.history.push("/Log")}
            />
          </div>
{
  this.state.settingArray?.find(url => url?.key === "EnableTargets")?.value === "1" ? (
    <div className="row floatRight Box-Shadow text-center">
      <label className="h6" style={{ color: "#ff0000" }}>
        <b>TARGETS</b>
      </label>

      <TbTargetArrow
        size={50}
        className="row align-items-center justify-content-center"
        style={{ color: "red", cursor: "pointer" }}
        onClick={() => this.props.history.push("/SalesGauge")}
      />
    </div>
  ) : (
    <div className="row floatRight Box-Shadow text-center disabled">
      <label className="h6" style={{ color: "#ff0000" }}>
        <b>TARGETS</b>
      </label>

      <TbTargetArrow
        size={50}
        className="row align-items-center justify-content-center"
        style={{ color: "red", cursor: "not-allowed", opacity: 0.5 }}
      />
    </div>
  )
}
          {}
        </div>

        {/* <div className="row text-center mt-4">
          <div className="col floatLeft invisible">
            <div
              className="btn btn-success sendReceive"
              onClick={this.showReceive}
            >
              <b>Receive Data</b>
            </div>
          </div>
          <div className="col floatRight">
            <div
              className={
                this.state.disableSend
                  ? "btn btn-success sendReceive disabled"
                  : "btn btn-success sendReceive"
              }
              onClick={this.showSend}
            >
              <b>Send/Receive Data</b>
            </div>
          </div>
        </div> */}
        <Modal
          show={this.state.showSend}
          onHide={this.closeSend}
          animation={false}
        >
          <Modal.Body>
            <SendingData
              history={this.props.history}
              isDone={this.updateIsDoneReceiving}
            ></SendingData>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showReceive}
          onHide={this.closeReceive}
          animation={false}
        >
          <Modal.Body>
            <CollectingASAP
              history={this.props.history}
              isDone={this.updateIsDoneReceiving}
            ></CollectingASAP>
          </Modal.Body>
        </Modal>
        {this.state.isDoneReceiving ? window.location.reload() : null}
        <div className="row mt-5" style={{ clear: "both" }}>
          <div className="col-sm-6 ">
            <div className="card bg-c-blue Box-Shadow order-card">
              <div
                className={
                  !this.state.disableDate
                    ? "btn card-block disabled"
                    : "btn card-block "
                }
                onClick={() => this.Client()}
              >
                <FcManager className="text-center" size={60} />
                <h3
                  className="m-b-20 text-center m-2 mb-2"
                  style={{ color: "white" }}
                >
                  CLIENTS
                </h3>
              </div>
            </div>
          </div>

          <div className="col-sm-6 ">
            <div className="card bg-c-blue order-card Box-Shadow">
              <div
                className={
                  !this.state.disableDate
                    ? "btn card-block disabled"
                    : "btn card-block"
                }
                onClick={() => this.productAsap()}
              >
                <FcSurvey size={60} />
                <h3
                  className="m-b-20 text-center m-2 mb-2"
                  style={{ color: "white" }}
                >
                  ITEMS
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 ">
            <div className="card bg-c-blue order-card Box-Shadow">
              <div
                className={
                  !this.state.disableDate
                    ? "btn card-block disabled"
                    : " btn card-block"
                }
                onClick={() => this.Schedule()}
              >
                <FcCalendar size={60} />
                <h3
                  className="m-b-20 text-center m-2 mb-2 "
                  style={{ color: "white" }}
                >
                  SCHEDULE
                </h3>
              </div>
            </div>
          </div>

          <div className="col-sm-6 ">
            <div className="card bg-c-blue order-card Box-Shadow">
              <div
                className={
                  !this.state.disableDate
                    ? "btn card-block disabled"
                    : "btn card-block"
                }
                onClick={() => this.props.history.push("/Reports2")}
              >
                <FcSalesPerformance size={60} />
                <h3
                  className="m-b-20 text-center m-2 mb-2"
                  style={{ color: "white" }}
                >
                  REPORTS
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 ">
            <div className="card bg-c-blue order-card Box-Shadow">
              <div
                className={
                  !this.state.disableDate
                    ? "btn card-block disabled"
                    : "btn card-block"
                }
                onClick={() => this.Journal()}
              >
                <FcNews size={60} />
                <h3
                  className="m-b-20 text-center m-2 mb-2"
                  style={{ color: "white" }}
                >
                  JOURNAL
                </h3>
              </div>
            </div>
          </div>

          <div className="col-sm-6 ">
            <div className="card bg-c-blue order-card">
              <div
                className={
                  !this.state.disableDate
                    ? "btn card-block disabled "
                    : "btn card-block "
                }
                onClick={this.showSend}
              >
                <FcSynchronize size={60} />
                <h3
                  className="m-b-20 text-center m-2 mb-2"
                  style={{ color: "white" }}
                >
                  SYNCRONIZE
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 ">
            <div className="card bg-c-blue order-card">
              <div
                className={
                  !this.state.disableDate
                    ? "btn card-block disabled "
                    : "btn card-block "
                }
                onClick={this.showAlert}
              >
                <FcEditImage size={60} />
                <h3
                  className="m-b-20 text-center m-2 mb-2"
                  style={{ color: "white" }}
                >
                  SYNC IMAGES
                </h3>
              </div>
            </div>
          </div>

          <div className="col-sm-6 ">
            <div className="card bg-c-blue order-card Box-Shadow">
              <div
                className="btn card-block col text-center m-2"
                onClick={this.showAlertChange}
              >
                <LogOutOutline
                  height="45px"
                  width="100px"
                  style={{ color: "red" }}
                />
                <h3
                  className="m-b-20 text-center m-2 mb-2"
                  style={{ color: "white" }}
                >
                  LOGOUT
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row mt-3">
          <div
            className={
              !this.state.disableDate
                ? "btn col Box-Shadow text-center m-2 disabled"
                : "btn Box-Shadow col text-center m-2"
            }
            style={stylesASAP.mainContainer}
            onClick={() => this.Client()}
          >
            <PeopleOutline
              className="row align-items-center justify-content-center"
              color={"#00bfff"}
              height="150px"
              width="150px"
            />
            <h4 className="card-text" style={stylesASAP.itemName}>
              Clients
            </h4>
          </div>
          <div
            className={
              !this.state.disableDate
                ? "btn col Box-Shadow text-center m-2 disabled"
                : "btn Box-Shadow col text-center m-2"
            }
            style={stylesASAP.mainContainer}
            onClick={() => this.productAsap()}
          >
            <ListSharp
              className="row align-items-center justify-content-center"
              color={"#00bfff"}
              height="150px"
              width="150px"
            />
            <h4 className="card-text" style={stylesASAP.itemName}>
              Items
            </h4>
          </div>
        </div> */}

        {/* <div className="row">
          <div
            className={
              !this.state.disableDate
                ? "btn col Box-Shadow text-center m-2 disabled"
                : "btn Box-Shadow col  text-center m-2"
            }
            style={stylesASAP.mainContainer}
            onClick={() => this.Schedule()}
          >
            <CalendarOutline
              className="row align-items-center justify-content-center"
              color={"#00bfff"}
              height="150px"
              width="150px"
            />
            <h4 className="card-text" style={stylesASAP.itemName}>
              Schedule
            </h4>
          </div>
          <div
            className={
              !this.state.disableDate
                ? "btn col Box-Shadow text-center m-2 disabled"
                : "btn Box-Shadow col  text-center m-2"
            }
            style={stylesASAP.mainContainer}
            onClick={() => this.props.history.push("/Report")}
          >
            <BookmarkOutline
              className="row align-items-center justify-content-center"
              color={"#00bfff"}
              height="150px"
              width="150px"
            />
            <h4 className="card-text" style={stylesASAP.itemName}>
              Reports
            </h4>
          </div>
        </div> */}

        {/* <div className="row">
          <div
            className={
              !this.state.disableDate
                ? "btn col Box-Shadow text-center m-2 disabled"
                : "btn Box-Shadow col  text-center m-2"
            }
            style={stylesASAP.mainContainer}
            onClick={() => this.Vendor()}
          >
            <PeopleOutline
              className="row align-items-center justify-content-center"
              color={"#00bfff"}
              height="150px"
              width="150px"
            />
            <h4 className="card-text" style={stylesASAP.itemName}>
              Vendors
            </h4>
          </div>
          <div
            className={
              !this.state.disableDate
                ? "btn col Box-Shadow text-center m-2 disabled"
                : "btn  Box-Shadow col  text-center m-2 "
            }
            style={stylesASAP.mainContainer}
            onClick={() => this.Journal()}
          >
            <JournalOutline
              className="row align-items-center justify-content-center"
              color={"#00bfff"}
              height="150px"
              width="150px"
            />
            <h4 className="card-text" style={stylesASAP.itemName}>
              Journal
            </h4>
          </div>

          <div
            className={
              !this.state.disableDate
                ? "btn col Box-Shadow text-center m-2 disabled invisible"
                : "btn  Box-Shadow col  text-center m-2 invisible"
            }
            style={stylesASAP.mainContainer}
            onClick={this.showAlertChange}
          >
            <LogOutOutline
              className="row align-items-center justify-content-center"
              color={"#00bfff"}
              height="150px"
              width="150px"
            />
            <h4 className="card-text" style={stylesASAP.itemName}>
              Logout
            </h4>
          </div>
        </div> */}

        {/* <div className="row">
          <div
            className={
              !this.state.disableDate
                ? "btn col Box-Shadow text-center m-2 disabled invisible"
                : "btn  Box-Shadow col  text-center m-2 invisible"
            }
            style={stylesASAP.mainContainer}
            onClick={this.showAlertChange}
          >
            <LogOutOutline
              className="row align-items-center justify-content-center"
              color={"#00bfff"}
              height="150px"
              width="150px"
            />
            <h4 className="card-text" style={stylesASAP.itemName}>
              Logout
            </h4>
          </div>
        </div> */}

        <Modal
          show={this.state.showAlertChange}
          onHide={this.closeAlertChange}
          animation={false}
        >
          <Modal.Header>
            <h5>Logout</h5>
          </Modal.Header>
          <Modal.Body>Are You Sure You Want To Logout?</Modal.Body>
          <Modal.Body>
            <div>
              <div
                className="savebutton btn "
                onClick={() => this.props.history.push("./")}
              >
                Logout
              </div>
              <div
                className="cancelButton btn"
                onClick={() => this.closeAlertChange()}
              >
                Cancel
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showAlert}
          onHide={this.closeAlert}
          animation={false}
        >
          <Modal.Header></Modal.Header>
          <Modal.Body>Are You Sure You Want To Sync Images ?</Modal.Body>
          <Modal.Body>
            <div>
              <div
                className="savebutton btn "
                onClick={() => this.showAlertImages()}
              >
                YES
              </div>
              <div
                className="cancelButton btn"
                onClick={() => this.closeAlert()}
              >
                NO
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showAlertImages} animation={false}>
          <Modal.Header className="text-center">
            <b>Images Sync</b>
          </Modal.Header>
          <div className="col">
            <ArrowBackCircle
              className=" btn"
              onClick={() => this.closeAlertImages()}
              color={"#65A0FF"}
              height="50px"
              width="50px"
            />
          </div>
          <Modal.Body className="text-center">
            <div className="container col-md-12">
              <div>
                <h3 className="pt-5">
                  Receiving Images. This may take few seconds.
                </h3>
                <ProgressBar
                  animated
                  now={this.state.imageCount}
                  max={this.state.allitems.length}
                />
                <h3 className="mt-3">
                  {this.state.imageCount + " of  " + this.state.allitems.length}
                </h3>
              </div>
              {/* <div className="row">
                {this.state.allitems.map((item, index) => {
                  return (
                    <div className="col-md-3">
                      <img
                        className="img-fluid"
                        src={
                          "https://asap.smartrep.me:442/images/Ghizzawi_Images/" +
                          item.default_code +
                          ".png?lastmode="+ this.state.random
                        }
                        alt="not found"
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                  );
                })}
              </div> */}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
